import feathersClient, { BaseModel, makeAuthPlugin } from "../feathers-client";

class Auth extends BaseModel {
  // eslint-disable-next-line no-useless-constructor
  constructor(data, options) {
    super(data, options);
  }

  static modelName = "Auth";

  static instanceDefaults() {
    return {
      email: "",
      password: "",
    };
  }
}

// override some of the base functionality for backwards compatibility
const servicePath = "auth";
const servicePlugin = makeAuthPlugin({
  Model: Auth,
  service: feathersClient.service(servicePath),
  servicePath,
  userService: "users",
  entityIdField: "id", // The property in the payload storing the user id
  responseEntityField: "user", // The property in the payload storing the user
  state: {},
  getters: {
    organizationId(state, getters) {
      return getters.user?.organizationId;
    },
    isAdmin(state, getters) {
      return getters.user?.roles?.includes("admin");
    },
    getAccessToken(state) {
      return state.accessToken;
    },
  },
  actions: {
    reauthenticate({ dispatch }) {
      return dispatch("authenticate");
    },
  },
});

export default servicePlugin;
